<template>
    <div class="patient-chart-score-history-modal">
        <b-row class="align-content-around">
            <div class="report-widget col text-center">
                <b-row>
                    <b-col>
                        <label>
                            {{ $i18n.gt('LABEL_TRENDS') }}
                        </label>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <b-btn class="col btn-sm" variant="primary" @click.stop="showTrendModal()">
                            {{ $i18n.gt('LABEL_VIEW_BUTTON') }}
                        </b-btn>
                    </b-col>
                </b-row>

            </div>
        </b-row>
        <b-modal :id="modalId" title="Trends" hide-footer size="lg">
            <b-row>
                <template v-if="$utils.themeIs('wellcoaches')">
                    <b-col cols="12" lg="12">
                        <h4>WBI Score Report</h4>
                        <b-row>
                            <participant-score-chart class="col-6" scores="WBI_MIND" :show-y-axis="true"
                                                     :y-values="[0,3,7,10]"/>
                            <participant-score-chart class="col-6" scores="WBI_BODY" :show-y-axis="true"
                                                     :y-values="[0,3,7,10]"/>
                        </b-row>
                        <b-row>
                            <participant-score-chart class="col-6" scores="WBI_LIFE" :show-y-axis="true"
                                                     :y-values="[0,3,7,10]"/>
                            <participant-score-chart class="col-6" scores="WBI_WORK" :show-y-axis="true"
                                                     :y-values="[0,3,7,10]"/>
                        </b-row>
                        <b-row>
                            <participant-score-chart class="col-6" scores="WBI_OVERALL" :show-y-axis="true"
                                                     :y-values="[0,3,7,10]"/>
                        </b-row>
                    </b-col>

                    <b-col cols="12" lg="12">
                        <h4>Positivity Report</h4>
                        <b-row>
                            <participant-score-chart class="col-6" scores="RATIO_SCORE"/>
                        </b-row>
                    </b-col>
                </template>

                <b-col cols="12" lg="12">
                    <h4>Lifestyle Report</h4>
                    <b-row>
                        <participant-score-chart class="col-6" scores="SCORE_EXER"/>
                        <participant-score-chart class="col-6" scores="SCORE_DIET"/>
                    </b-row>
                    <b-row>
                        <participant-score-chart class="col-6" scores="SCORE_STRESS"/>
                        <participant-score-chart class="col-6" scores="SCORE_SLEEP"/>
                    </b-row>
                    <b-row>
                        <participant-score-chart class="col-6" scores="TOTAL_SCORE"/>
                    </b-row>
                </b-col>
                <b-col cols="12" lg="12">
                    <h4>Legend</h4>
                    <b-row>
                        <b-col style="display: flex; justify-content: space-around">
                            {{ $i18n.gt('LABEL_GAUGE_LOW_RISK') }}
                            <div style="height:2em; width: 2em; background-color: #00E81D4D"></div>
                        </b-col>
                        <b-col style="display: flex; justify-content: space-around">
                            {{ $i18n.gt('LABEL_GAUGE_INCREASED_RISK') }}
                            <div style="height:2em; width: 2em; background-color: #FFF8154D"></div>
                        </b-col>
                        <b-col style="display: flex; justify-content: space-around">
                            {{ $i18n.gt('LABEL_GAUGE_HIGH_RISK') }}
                            <div style="height:2em; width: 2em; background-color: #FFAA154D"></div>
                        </b-col>
                        <b-col style="display: flex; justify-content: space-around">
                            {{ $i18n.gt('LABEL_GAUGE_VERY_HIGH_RISK') }}
                            <div style="height:2em; width: 2em; background-color: #EB001B4D"></div>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
        </b-modal>
    </div>
</template>

<!-- ----------------------------------------------------------------------- -->

<script>

import Vue from 'vue'

export default Vue.extend({
    name: 'PatientChartScoreHistoryModal',
    computed: {
        participant () {
            return this.$store.state.patientParticipant
        },
        modalId () {
            return 'modal_trends'
        },
    },
    methods: {
        showTrendModal () {
            this.$bvModal.show(this.modalId)
        }
    },
    async mounted () {
        try {
            await this.$store.dispatch('getParticipantScores', { participantId: this.$store.state.patientParticipant.id })
        } catch (e) {
            this.$utils.handleError(e, 'Could not load scores')
        }
    },
})
</script>

<style lang="scss">

.report-widget {
    cursor: pointer;

    .card {
        background: #fff;
        transition: all .3s;
        margin-bottom: 0;
        @media(min-width: 540px) {
            height: 100%;
        }

        &:hover {
            box-shadow: 0 0 10px rgba(0, 0, 0, .15);

            .report-widget__timestamp {
                color: var(blue);
            }
        }
    }

    @media(max-width: 719px) {
        margin-bottom: 1rem;
    }

}

</style>
